import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";

export default function ResidencyCitizenshipDominica() {

    return (
        <main className='main'>
            <IntroSection
                title="Residency & Citizenship – Dominica"
                subtitle="Second Citizenship & Offshore Residency Options"
                description="Dominica is globally renowned for its Citizenship by Investment (CBI) Program, one of the oldest and most respected in the Caribbean. It provides investors and families with lifetime citizenship, visa-free travel, and asset protection benefits."
                badges={[
                    "Citizenship in 3–6 Months",
                    "Visa-Free Travel to 140+ Countries",
                    "No Residency Requirement"
                ]}
                buttonText="Request a Dominica Residency Consultation →"
                buttonLink="/quote"
                imageSrc={require("../../assets/images/residency-passport/residency-citizenship-dominica-hero.png")}
                imageAlt="Dominica Citizenship & Residency"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Dominica Citizenship or Residency?'
                        blocks={[
                            {
                                items: [
                                    { title: "Affordable CBI Program", text: "Starting from USD 100,000." },
                                    { title: "Fast Processing", text: "Approval within 3–6 months." },
                                    { title: "Visa-Free Travel", text: "Schengen Zone, UK, Singapore, and 140+ countries." },
                                    { title: "No Residency Obligation", text: "No requirement to live in Dominica." },
                                    { title: "Tax Benefits", text: "No capital gains, inheritance, or foreign income tax." },
                                    { title: "Family Inclusion", text: "Spouse, children, and dependent parents eligible." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Citizenship by Investment (CBI) Program"
                        blocks={[
                            {
                                title: "1. Donation Option",
                                items: [
                                    { text: "Contribution of USD 100,000 to the Economic Diversification Fund (EDF)." },
                                    { text: "Non-refundable." },
                                    { text: "Most affordable route for single applicants." }
                                ]
                            },
                            {
                                title: "2. Real Estate Option",
                                items: [
                                    { text: "Minimum USD 200,000 investment in approved real estate projects." },
                                    { text: "Property must be held for at least 3 years." },
                                    { text: "Eligible for rental income and resale after holding period." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Permanent Residency in Dominica"
                        blocks={[
                            {
                                title: "",
                                items: [
                                    { text: "Available through long-term residence or company operations." },
                                    { text: "Easier path for those doing business in Dominica via IBCs or local structures." },
                                    { text: "Can lead to naturalization after several years, but CBI is much faster." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Key Benefits of Dominica Citizenship"
                        services={[
                            { title: "Global Mobility", text: "Visa-free access to 140+ countries." },
                            { title: "Business Opportunities", text: "Offshore company structures and banking access." },
                            { title: "Wealth Protection", text: "Tax neutrality and asset security." },
                            { title: "Family Coverage", text: "Extend citizenship to spouse, children, and parents." },
                            { title: "Dual Citizenship", text: "No obligation to renounce existing nationality." }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Looking for affordable second citizenship?"
                        description="Offshore Advisory assists with Dominica CBI applications, real estate investments, and residency structuring."
                        buttonText="Book a Dominica Citizenship Consultation Today →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "How long does it take to obtain Dominica citizenship?",
        content: [
            { type: "answer", text: "Typically 3–6 months." },
        ],
    },
    {
        question: "Can I pass citizenship to my children?",
        content: [
            { type: "answer", text: "Yes, Dominica citizenship is hereditary." },
        ],
    },
    {
        question: "Do I need to live in Dominica to maintain citizenship?",
        content: [
            { type: "answer", text: "No, there is no residency requirement." },
        ],
    },
    {
        question: "Which countries can I travel visa-free with a Dominica passport?",
        content: [
            { type: "answer", text: "140+ countries, including Schengen Zone, UK, Hong Kong, and Singapore." },
        ],
    },
    {
        question: "Is real estate investment refundable?",
        content: [
            { type: "answer", text: "The property can be resold after 3 years, but the minimum investment threshold must be met." },
        ],
    },
];
